// Redux util
// Redux Utils
import { useDispatch, useSelector } from "react-redux";
import { resendConfirmationCode } from "@/features/confirm/confirmThunks";

// React Utils
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import AppWhoopLogo from "@/assets/appwhoop_ticket_logo.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ReenviarCodigoParaConfirmarUsuario() {
  // Redux
  const dispatch = useDispatch();
  const { sendCode, error } = useSelector((state) => state.confirm);
  console.log("sendCode:", sendCode);
  console.log("error:", error);

  // local state
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: "",
  });

  // Hooks
  const navigate = useNavigate();

  // Validación del formulario
  const validate = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = "El correo electrónico es obligatorio";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "El formato del correo electrónico no es válido";
    } else if (formData.email.length > 50) {
      newErrors.email = "El correo no puede tener más de 50 caracteres";
    }

    return newErrors;
  };
  // Maneja el envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validate();
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Aquí puedes manejar el envío del formulario
      dispatch(resendConfirmationCode({ email: formData.email }));
      setTimeout(() => {
        navigate("/confirmar-usuario");
      }, 2000);
    } else {
      console.log("Errores de validación:", newErrors);
    }
  };
  // Maneja cambios en el input de email
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, email: value });

    // Limpiar errores de email cuando el usuario esté escribiendo
    if (errors.email && value.trim()) {
      setErrors((prev) => ({ ...prev, email: "" }));
    }
  };

  return (
    <main
      id="app-content"
      className="flex flex-col items-center justify-center min-h-screen bg-aw-bgbluedark"
    >
      <div
        id="bck-cooming-soon"
        className="flex flex-col items-center justify-center w-full min-h-screen"
      >
        <div className="relative flex flex-col justify-center gap-y-3 p-4 md:w-2/3 2xl:w-3/7 h-[80dvh] bg-aw-bluedark-75 rounded-lg shadow-lg">
          <Link
            to="/"
            className="absolute top-4 left-4 text-white hover:text-aw-green transition-colors duration-200"
          >
            <FontAwesomeIcon
              icon="fa-solid fa-arrow-left"
              className="inline-block mr-2"
            />
            Volver al Home
          </Link>
          <div className="flex items-center justify-center">
            <LazyLoadImage
              alt="AppWhoop Logo"
              effect="blur"
              wrapperProps={{
                // If you need to, you can tweak the effect transition using the wrapper style.
                style: { transitionDelay: "0.3s" },
              }}
              src={AppWhoopLogo}
              className="w-4/5 sm:w-1/2 xl:w-2/5 object-contain mx-auto"
            />
          </div>
          <div className="flex flex-col text-center items-center justify-center text-white">
            <h2 className="text-xl sm:text-3xl font-bold text-aw-green">
              Enviar Código de Confirmación
            </h2>
            <p className="text-sm text-white">
              Ingresa tu correo electrónico para recibir un nuevo código de
              verificación y activar tu cuenta.
            </p>
          </div>
          <div className="flex text-center items-center justify-center">
            {/* Formulario para ingresar correo y código de confirmación para activar usuario */}
            {sendCode == false && error == null ? (
              <form
                onSubmit={handleSubmit}
                className="w-full max-w-md text-white rounded-lg p-4 shadow-md"
              >
                <div className="mb-4">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleEmailChange}
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 text-white placeholder:text-gray-400 ${
                      errors.email
                        ? "border-red-500 focus:ring-red-500"
                        : "border-gray-300 focus:ring-aw-bluedark"
                    }`}
                    placeholder="Ingresa tu correo electrónico"
                  />
                  {errors.email && (
                    <span className="text-xs text-red-400 mt-1 block">
                      {errors.email}
                    </span>
                  )}
                </div>
                <button
                  type="submit"
                  disabled={!formData.email.trim()}
                  className="w-full py-2 px-4 disabled:bg-gray-400 disabled:hover:!cursor-not-allowed text-aw-dark font-semibold bg-aw-green rounded-md duration-200"
                >
                  Reenviar Código de Confirmación
                </button>
              </form>
            ) : sendCode == true && error == null ? (
              <div className="w-full max-w-md text-white rounded-lg p-4 shadow-md">
                <p className="text-center text-green-400 font-semibold">
                  ¡Código de confirmación reenviado! Revisa tu correo
                  electrónico.
                </p>
                <span className="flex justify-center items-center">
                  Redirigiendo...
                  <FontAwesomeIcon
                    icon="fa-solid fa-arrows-spin"
                    className="text-green-400 text-4xl animate-spin ml-4"
                  />
                </span>
              </div>
            ) : (
              <div className="w-full max-w-md text-white rounded-lg p-4 shadow-md">
                <p className="text-center text-red-400">{error.message}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
